import axios from '@/axios.js'

export default {
  fetchUsers ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_GATEWAY_BASE_PATH  }/Mt5-Api/GetUserList`)
        .then((response) => {
          commit('SET_USERS', response.data)
        })
        .catch((error) => { 
          commit('SET_USERS', [])
          reject(error)
        })
    })
  },


  addAccount ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_GATEWAY_BASE_PATH  }/Mt5-Api/UserRecordNew?Server=${params.serverType}`, params)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => { 
          
          reject(error)
        })
    })
  },


  // fetchUser ({ commit }, userId) {
  //   return new Promise((resolve, reject) => {
  //     axios.get(`${process.env.VUE_APP_API_GATEWAY_BASE_PATH  }/Mt5-Api/GetUser/${userId}`)
  //       .then((response) => {
  //         commit('SET_USER', response.data)
  //       })
  //       .catch((error) => { 
  //         commit('SET_USER', null)
  //         reject(error) 
  //       })
  //   })
  // },

  fetchAccountsByEmail (content, payload) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_GATEWAY_BASE_PATH  }/Mt5-Api/Accounts/ByEmail?email=${payload.email}&server=${payload.server}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { 
          reject(error) 
        })
    })
  },


  fetchAccountByLogin (content, payload) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_GATEWAY_BASE_PATH  }/Mt5-Api/Accounts/LoginID?LoginID=${payload.loginID}&server=${payload.server}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { 
          reject(error) 
        })
    })
  },


  fetchClientHistory (content, payload) {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_GATEWAY_BASE_PATH  }/Mt5-Api/GetUserTradeHistory?Login=${payload.client}&dateFrom=${payload.start}&dateTo=${payload.end}&ServerType=${payload.server}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { 
          reject(error) 
        })
    })
  },

  // fetchOrders ({ commit }) {
  //   return new Promise((resolve, reject) => {
  //     axios.get(`${process.env.VUE_APP_API_GATEWAY_BASE_PATH  }/TradesRequest`)
  //       .then((response) => {
  //         commit('SET_ORDERS', response.data)
  //       })
  //       .catch((error) => { 
  //         commit('SET_ORDERS', [])
  //         reject(error)
  //       })
  //   })
  // },

  // UsersGroupOp ({commit}, params) {
  //   console.error(params)
  //   return new Promise((resolve, reject) => {
  //     const queryString = Object.keys(params).map(key => key + '=' + params[key]).join('&')
  //     axios.post(`${process.env.VUE_APP_API_GATEWAY_BASE_PATH  }/Mt5-Api/UsersGroupOperation?ServerType=${params.serverType}?logins=${params.logins}`, params)
  //       .then((response) => {
  //         resolve(response.data)
  //       })
  //       .catch((error) => { 
  //         reject(error)
  //       })
  //   })
  // },

  UserPasswordChange ({commit}, params) {
    return new Promise((resolve, reject) => {
      const queryString = Object.keys(params).map(key => key + '=' + params[key]).join('&')
      axios.get(`${process.env.VUE_APP_API_GATEWAY_BASE_PATH  }/Mt5-Api/UserPasswordChange?${queryString}`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => { 
          reject(error)
        })
    })
  }

  // UserInvestorPasswordSet ({commit}, params) {
  //   return new Promise((resolve, reject) => {
  //     const queryStrıng = Object.keys(params).map(key => key + '=' + params[key]).join('&')
  //     axios.post(`${process.env.VUE_APP_API_GATEWAY_BASE_PATH  }/Mt5-Api/api/UserInvestorPasswordSet?${queryStrıng}`)
  //       .then((response) => {
  //         resolve(response.data)
  //       })
  //       .catch((error) => { 
  //         reject(error)
  //       })
  //   })
  // }
}
